import { Injectable, OnInit } from '@angular/core';
import { ApiBaseService } from './api-base.service';
import { Subject } from 'rxjs';
import { GetProjectResultModel } from '../interfaces/entities/project';

@Injectable({
  providedIn: 'root'
})
export class ProjectService {


  constructor(private service: ApiBaseService) { }

  private refreshMilestones = new Subject<void>();
  private refreshProjectInfo = new Subject<void>();

  refreshMilestones$ = this.refreshMilestones.asObservable();
  refreshProjectInfo$ = this.refreshProjectInfo.asObservable();

  async getProjectMilestones(payload: any): Promise<any> {
    return this.service.httpRequest('ProjectService/GetProjectMilestones', payload, true, false);
  }

  async getProject(payload: { ProjectId: number } | { projectId: number }): Promise<GetProjectResultModel> {
    return this.service.httpRequest('ProjectService/GetProject', payload, true, true);
  }

  async createNewProject(payload: any): Promise<any> {
    return this.service.httpRequest('ProjectService/CreateNewProject', payload, true, true);
  }

  async deleteProject(payload: any): Promise<any> {
    return this.service.httpRequest('ProjectService/DeleteProject', payload, true, true)
  }

  async updateProjectStatus(payload: any): Promise<any> {
    return this.service.httpRequest('ProjectService/DeleteProject', payload, true, false)
  }

  async triggerRefreshMilestones() {
    this.refreshMilestones.next();
  }

  triggerRefreshProjectInfo() {
    this.refreshProjectInfo.next();
  }

  async addProjectAsFavorite(payload: any): Promise<any> {
    return this.service.httpRequest('ProjectService/AddProjectAsFavorite', payload, true, false);
  }

  async removeProjectAsFavorite(payload: any): Promise<any> {
    return this.service.httpRequest('ProjectService/RemoveProjectAsFavorite', payload, true, false);
  }

  async getCommentCount(payload: any): Promise<any> {
    return this.service.httpRequest('CommentService/GetCommentCount', payload, true, true);
  }
}
